var map = {
	"./avatar.svg": 7267,
	"./car.svg": 2362,
	"./cargo.svg": 5852,
	"./copy.svg": 7399,
	"./error.svg": 6114,
	"./gas.svg": 39,
	"./input.mp4": 288,
	"./input.svg": 8132,
	"./input.webm": 3552,
	"./output.mp4": 3805,
	"./output.svg": 4855,
	"./output.webm": 3031,
	"./pc.mp4": 2997,
	"./pc.webm": 6223,
	"./process.webp": 240,
	"./sos.svg": 4209,
	"./speed.svg": 3881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4608;